module.exports = __webpack_public_path__ + "static/media/cook_food_important.13348acf.svg";